var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelVentCerrada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 10.44L11.29 4.28001L9.53998 3.26001V5.29001V18.16V18.83L10.12 19.16L20.71 25.32L22.46 26.34V24.31V11.45V10.77L21.88 10.44Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 11.45L10.7 5.29001V18.16L21.3 24.31V11.45Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 22.62L12.11 17.28V6.10001L10.7 5.29001V16.46V18.16L12.11 18.97L21.3 24.31V22.62Z",
    fill: "#DDDDDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 17.28V6.10001L10.7 5.29001V16.46V18.16L12.11 17.28Z",
    fill: "#A6A6A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 11.45L10.7 5.29001V18.16L21.3 24.31V11.45Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.87 18.75V15.91",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelVentCerrada);
export default __webpack_public_path__ + "static/media/SelVentCerrada.857609f6ac5f50a275b6304b34c1f9d9.svg";
export { ForwardRef as ReactComponent };